import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, makeStyles, Typography } from "@material-ui/core";
import { DataGrid } from "devextreme-react";
import { Column, Pager, Paging } from "devextreme-react/data-grid";
import closeIcon from "../../images/closeIcon.svg"

const useStyles = makeStyles({
    divider:{
        backgroundColor: "#000"
    },
    dialogActions:{
        padding: "0.5rem 1.5rem 1.5rem 1.5rem", 
        display: "flex", 
        alignItems: "center", 
        columnGap: "1rem"
    }
})


function FileImportDetail(props)
{
    const {open, data, closeFunction} = props;
    const elementsError = open ? data.numberOfElementsSent - data.numberOfElementsInserted : 0
    const classes = useStyles()
    const pageSize = 10

    return(
        <Dialog PaperProps={{square: true}} maxWidth={"md"} open={open} onClose={closeFunction}>
               <DialogTitle disableTypography className="titleStyles">
                <span>Detalhe Importação {data?.fileName}</span>
                <IconButton size='small' onClick = {closeFunction}><img height={15} src={closeIcon} title={"Cerrar"}/> </IconButton>
                </DialogTitle>
                <Divider classes={{root: classes.divider}}/>
                <DialogContent>
                    <div className="import-detail-summary">
                        <div className="import-detail-item"><span style={{fontWeight: 700}}>Elementos enviados: </span> {data?.numberOfElementsSent}</div>
                        <div className="import-detail-item"><span style={{fontWeight: 700}}>Elementos adicionados: </span> {data?.numberOfElementsInserted}</div>
                        <div className="import-detail-item"><span style={{fontWeight: 700}}>Elementos com erro: </span> {elementsError}</div>
                    </div>
                    <DataGrid  noDataText="Importação completa sem erros" dataSource={data?.importErrors}>
                        <Column width={"75px"} dataField={"excelRow"} dataType={"number"} caption={"Fila"}/>
                        <Column dataField={"errorMessage"} dataType={"string"} caption={"Error"}/>
                        <Paging defaultPageSize={pageSize} />
                        <Pager
                          visible={data && pageSize < data?.importErrors.length}
                          displayMode={"full"}
                          showPageSizeSelector={false}
                          showInfo={false}
                          showNavigationButtons
                        />
                    </DataGrid>
                </DialogContent>
                <DialogActions classes={{root: classes.dialogActions}}>
                    <Button onClick={closeFunction} color='primary' variant='contained'>Aceptar</Button>  
                </DialogActions> 
        </Dialog>
    )
}

export {FileImportDetail}